import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";
 
export default () => {

  const moduleName = "rewards";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.rewards_destroy, location.search]);

  useEffect(() => {
    if (appReducer.rewards_list != undefined) {
      setRows(appReducer.rewards_list.data)
      setTotalPages(appReducer.rewards_list.count)
    }
  }, [appReducer])

  const columns = [
    {
      name: 'نام',
      selector: row => row.name,
    },
    {
      name: 'امتیاز مورد نیاز',
      selector: row => row.rate,
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table count={totalPages}  columns={columns} data={rows} />;

};
